export const CST = {
    SCENES: {
        BOOT: "BOOT",
        PRELOAD: "PRELOAD",
        MENU: "MENU",
        BUBBLESINTRO: "BUBBLESINTRO",
        BUBBLES: "BUBBLES",
        QUIZ: "QUIZ",
        QUESTION: "QUESTION",
        ENDSCREEN: "ENDSCREEN",
        ENDSCREENQUIZ: "ENDSCREENQUIZ"
    },
    TEXTSTYLES: {
        TITLESTYLE: {
            fontFamily: "Arial",
            fontSize: "50px",
            color: "#000",
            fontStyle: "bold"
        },
        SCORING: {
            fontFamily: "Arial",
            fontSize: "38px",
            color: "#000",
            fontStyle: "bold"
        },
        TEAMNAME: {
            fontFamily: "Arial",
            fontSize: "30px",
            color: "#000",
            fontStyle: "bold"
        },
        TEAMLEADERBOARD: {
            fontFamily: "Arial",
            fontSize: "40px",
            color: "#000"
        },
        BUTTONSSTYLE: {
            fontFamily: "Arial",
            fontSize: "32px",
            color: "#fff"
        },
        QUESTIONSTYLE: {
            fontFamily: "Arial",
            fontSize: "32px",
            color: "#000",
            wordWrap: {
                width: 1025
            }
        },
        TIMERSTYLE: {
            fontFamily: "Arial",
            fontSize: "66px",
            color: "#000"
        },
        TIMERSTYLEMAGIC: {
            fontFamily: "Arial",
            fontSize: "66px",
            color: "#000"
        },
        POINTS: {
            fontFamily: "Arial",
            fontSize: "42px",
            color: "#000"
        },
        ENDSCREENTEXT: {
            fontFamily: "Arial",
            fontSize: "90px",
            color: "#000",
            fontStyle: "bold"
        },
        ENDSCREENQUIZ: {
            fontFamily: "Arial",
            fontSize: "50px",
            color: "#000",
            fontStyle: "bold"
        },
    }
}